import React, { useState } from "react";
import {
  Button,
  Typography,
  makeStyles,
} from "@material-ui/core";
import PropTypes from "prop-types";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { ForecastTable } from "./ForecastTable";

const useStyles = makeStyles((theme) => ({
  forecastButton: {
    backgroundColor: "#FDD835",
    color: "#000",
    padding: theme.spacing(1),
    borderRadius: "10px",
    width: "100%",
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#FDD835",
    },
  },
  tableContainer: {
    width: "100%",
    margin: theme.spacing(1),
  },
  tableHead: {
    backgroundColor: "#f5f5f5",
  },
  tableCell: {
    padding: theme.spacing(1),
    textAlign: "center",
  },
  dayColumn: {
    fontWeight: "bold",
    textAlign: "left",
  },
  forecastRow: {
    backgroundColor: "#f9f9f9",
    borderBottom: "1px solid #ddd",
  },
  forecastIcon: {
    display: "flex",
    justifyContent: "center",
  },
  iconSmall: {
    fontSize: "1rem",
  },
  arrowIcon: {
    marginLeft: 'auto',
    fontSize: '1.5rem', 
  }
}));

const DropdownForecast = ({ fullWidth, dataPronostico }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };


  return (
    <div style={{ width: fullWidth ? "100%" : "auto" }}>
      <Button
        disabled={dataPronostico.length === 0}
        className={classes.forecastButton}
        onClick={handleClick}
      >
        <Typography variant="inherit">Pronóstico</Typography>
        <ArrowDropDownIcon className={classes.arrowIcon} style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }} />
      </Button>
      {open && <ForecastTable dataPronostico={dataPronostico} />}
    </div>
  );
};

export default DropdownForecast;

DropdownForecast.propTypes = {
  fullWidth: PropTypes.bool.isRequired,
  dataPronostico: PropTypes.arrayOf(
    PropTypes.shape({
      dia: PropTypes.string.isRequired,
      morning: PropTypes.shape({
        tempMax: PropTypes.number,
        tempMin: PropTypes.number,
        condition: PropTypes.string,
      }),
      afternoon: PropTypes.shape({
        tempMax: PropTypes.number,
        tempMin: PropTypes.number,
        condition: PropTypes.string,
      }),
      night: PropTypes.shape({
        tempMax: PropTypes.number,
        tempMin: PropTypes.number,
        condition: PropTypes.string,
      }),
    })
  ).isRequired,
};
